
import { Video, Megaphone } from "lucide-react";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { Label } from "@/components/ui/label";
import { Card, CardContent } from "@/components/ui/card";

interface ContentTypeFilterProps {
  postTypeFilter: string;
  onPostTypeFilterChange: (value: string) => void;
}

export const ContentTypeFilter = ({ postTypeFilter, onPostTypeFilterChange }: ContentTypeFilterProps) => {
  return (
    <Card className="border-none" style={{ backgroundColor: '#e0F2Eb' }}>
      <CardContent className="p-3">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-2">
            <span className="font-medium text-sm" style={{ color: '#30565c' }}>Content Type</span>
          </div>
          <RadioGroup
            value={postTypeFilter}
            onValueChange={onPostTypeFilterChange}
            className="flex space-x-4"
          >
            <div className="flex items-center space-x-2">
              <RadioGroupItem value="all" id="all-types" />
              <Label htmlFor="all-types" className="text-xs cursor-pointer" style={{ color: '#30565c' }}>All</Label>
            </div>
            <div className="flex items-center space-x-2">
              <RadioGroupItem value="videos" id="crop-videos" />
              <Label htmlFor="crop-videos" className="text-xs flex items-center space-x-1 cursor-pointer" style={{ color: '#30565c' }}>
                <Video size={12} style={{ color: '#30565c' }} />
                <span>Crop Updates</span>
              </Label>
            </div>
            <div className="flex items-center space-x-2">
              <RadioGroupItem value="casts" id="iso-casts" />
              <Label htmlFor="iso-casts" className="text-xs flex items-center space-x-1 cursor-pointer" style={{ color: '#30565c' }}>
                <Megaphone size={12} style={{ color: '#30565c' }} />
                <span>ISO Casts</span>
              </Label>
            </div>
          </RadioGroup>
        </div>
      </CardContent>
    </Card>
  );
};
